import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import DetailPage from '../../containers/expertise/DetailPage';
import {
  directionalDrillingForUtilityProjects,
  waterSewageSystemPipelineFacilities,
  waterUtilityServicesHeroSection,
} from '../../images/expertise/water-service';

const WaterUtilityServices: NextPage = () => {
  return (
    <>
      <Header
        title="Water Utilities"
        description="Utilities One offers comprehensive water utility services to ensure efficient, reliable water distribution and infrastructure solutions."
        image={waterUtilityServicesHeroSection}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: waterSewageSystemPipelineFacilities,
            id: 'waterSewageSystemPipelineFacilities',
            hasListItems: true,
            title: 'Water and Sewage System Pipeline Facilities',
            description:
              'We present the best emergency solutions for residential and business customers. Our crew takes control over your water delivery systems, and ensures a quality approach to the sewage system pipelines.',
            listItems: [
              { text: 'Pipeline Facilities' },
              { text: 'Pump & Lift Station' },
              { text: 'Water Transmission' },
              { text: 'Drainage' },
              { text: 'Sewage System Lines' },
              { text: 'Energy Lines' },
              { text: 'Maintenance/Emergency repairs' },
            ],
          },
          {
            bgImage: directionalDrillingForUtilityProjects,
            id: 'meteringInstallationServices',
            hasListItems: true,
            title: 'Metering Installation Services',
            description:
              'We offer complete metering installation services for water and sewer systems, supporting accurate measurement and regulatory compliance.',
            listItems: [
              {
                boldText: 'Water Meter Installation:',
                text: 'Efficient setup of residential, commercial, and industrial water meters',
              },
              { boldText: 'Meter Replacement & Upgrades:', text: 'Upgrading outdated systems for better accuracy' },
              { boldText: 'Data Collection & Monitoring:', text: 'Real-time tracking and reporting for usage analysis' },
              { boldText: 'System Integration:', text: 'Seamless integration with existing infrastructure' },
              { boldText: 'Maintenance & Calibration:', text: 'Regular upkeep to ensure accuracy and longevity' },
            ],
          },
        ]}
      />
    </>
  );
};

export default WaterUtilityServices;
